import * as React from 'react';
import icon from '../../assets/img/flags/tennessee.svg';

export const Tennessee = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
